import { useState } from 'react';

const faqs = [
  { q: 'Musím něco instalovat nebo nastavovat?', a: 'Ne. Vše nastavíme za vás — propojení systémů, mapování dat, předkontace v Money S3. Vy nám jen dáte přístupy a my se postaráme o zbytek. Celé to trvá 24–48 hodin.' },
  { q: 'Co když používám systém, který tady nevidím?', a: 'Napište nám. Většinu nových integrací dokážeme vytvořit do 2 týdnů. Navíc máme AI Mapper pro CSV, XLSX a XML soubory — takže i systém, který nemá API, se dá napojit.' },
  { q: 'Nepřijdu o kontrolu nad svými daty?', a: 'Naopak — získáte víc kontroly než teď. V portálu vidíte každý přenesený doklad, každou chybu, kompletní logy. Data validujeme před importem. Nic se neimportuje „naslepo".' },
  { q: 'Je to bezpečné?', a: 'Data jsou šifrovaná při přenosu (TLS) i v klidu. Servery běží v EU. Přístupové údaje k vašim systémům ukládáme šifrovaně. Jsme certifikovaný partner Seyfor pro Money S3.' },
  { q: 'Co když se něco pokazí během synchronizace?', a: 'Každý doklad se validuje před importem. Pokud něco nesedí, systém vás upozorní. Problémový záznam se neimportuje, ostatní běží dál. U přechodných chyb se sync automaticky opakuje.' },
  { q: 'Mám 40+ klientů. Zvládne to?', a: 'Ano — SyncroX je stavěný pro účetní kanceláře s desítkami klientů. Každá účetní jednotka má vlastní konfiguraci. Čím víc dokladů, tím nižší cena za kus.' },
  { q: 'Jak fungují manažerské reporty?', a: 'Reporty se generují automaticky z dat, která procházejí synchronizací. Vidíte tržby, marže po kanálech, cash flow výhled — aktuální ke dnešnímu dni. Není to náhrada účetního softwaru, je to pohled pro majitele firmy.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="faq-section">
      <div className="container">
        <div className="section-header"><h2>Časté otázky</h2></div>
        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item${open === i ? ' open' : ''}`}>
              <button className="faq-question" onClick={() => setOpen(open === i ? -1 : i)}>
                {faq.q}<span className="faq-toggle">+</span>
              </button>
              <div className="faq-answer">{faq.a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
